import React, { FunctionComponent, useCallback } from 'react'
import { Trans, useTranslation } from 'next-i18next'
import { TermLink } from '../../TermLink'
import { Text } from '@afterpaytouch/core'
import { useOpenExistingFacility, useSelectedPaymentType } from '../../../state'
import { useCheckoutSizes } from '../../../utils/responsive'
import { PaymentType } from '@afterpay/types'
import styles from './style.module.css'
import { TrackingEvent } from '../../../model/monitoring'
import { useMonitoringWithEnduringEventProperties } from '../../../integrations/monitoring'

export const PaymentTypesTerms: FunctionComponent = () => {
  const { t } = useTranslation()
  const selectedPaymentType = useSelectedPaymentType()
  const { extraSmallTextSize } = useCheckoutSizes()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const openExistingFacility = useOpenExistingFacility()
  const sendAnalyticsEvent = useCallback((): void => logEvent(TrackingEvent.PRESSED_CL_ENTRY_PAGE_DISCLAIMER_LINK), [logEvent])

  const components = {
    terms: (
      <TermLink
        key='payment-options-terms'
        color='Orca'
        href={t('consumerLending:termsOfServiceUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
      />
    ),
    privacy: (
      <TermLink
        key='payment-options-privacy'
        color='Orca'
        href={t('common:privacyPolicyUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
      />
    ),
    febPrivacy: (
      <TermLink
        key='payment-options-feb-privacy'
        color='Orca'
        href={t('consumerLending:febPrivacyPolicyUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
      />
    ),
    creditReportAuthorization: (
      <TermLink
        key='payment-options-credit-report-authorization'
        color='Orca'
        href={`${t('consumerLending:termsOfServiceUrl')}#credit-check`}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
      />
    ),
    consent: (
      <TermLink
        key='payment-options-consent'
        color='Orca'
        href={`${t('consumerLending:termsOfServiceUrl')}#e-sign`}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
      />
    ),
    creditGuide: (
      <TermLink
        key='payment-options-credit-guide'
        color='Orca'
        href={t('consumerLending:creditGuide')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
      />
    ),
    creditReportingCollectionNotice: (
      <TermLink
        key='payment-options-credit-reporting-collection-notice'
        color='Orca'
        href={t('consumerLending:creditReportingCollectionNotice')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
      />
    ),
  }

  return !openExistingFacility && selectedPaymentType === PaymentType.PCL ? (
    <div className={styles.termsWrapper}>
      <Text color='Gray40' size={extraSmallTextSize}>
        <Trans i18nKey='consumerLending:paymentOptions:terms' components={components} />
      </Text>
    </div>
  ) : null
}
